export const TICKET_REPAIR_REPORT_MAX_BYTES = 10 * 1024 * 1024;

const MIME_TYPE_BY_EXTENSION = {
	doc: 'application/msword',
	docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
	jpeg: 'image/jpeg',
	jpg: 'image/jpeg',
	pdf: 'application/pdf',
	png: 'image/png',
	webp: 'image/webp',
};

const EXTENSION_BY_MIME_TYPE = Object.entries(MIME_TYPE_BY_EXTENSION).reduce((extensions, [extension, mimeType]) => ({
	...extensions,
	[mimeType]: extensions[mimeType] || extension,
}), {});

export const TICKET_REPAIR_REPORT_PICKER_MIME_TYPES = [...new Set(Object.values(MIME_TYPE_BY_EXTENSION))];

export const validateTicketRepairReportSize = size => {
	const sizeBytes = typeof size === 'string' && size.trim()
		? Number(size)
		: size;

	if (!Number.isFinite(sizeBytes) || sizeBytes < 0) {
		throw new Error('Unable to determine the report size');
	}

	if (sizeBytes > TICKET_REPAIR_REPORT_MAX_BYTES) {
		throw new Error('File must be 10 MB or smaller');
	}

	return sizeBytes;
};

export const validateTicketRepairReportAssetSize = async asset => {
	if (!asset?.uri) {
		throw new Error('Unable to read the selected report');
	}

	const fileResponse = await fetch(asset.uri);
	const fileBlob = await fileResponse.blob();
	return validateTicketRepairReportSize(fileBlob?.size);
};

export const normalizeTicketRepairReportAsset = asset => {
	if (!asset?.uri) {
		throw new Error('Unable to read the selected report');
	}

	const fileName = asset.name || asset.fileName || '';
	const fileExtension = String(fileName).split('.').pop().toLowerCase();
	const [providedMimeType] = String(asset.mimeType || '').toLowerCase().split(';');
	const extension = MIME_TYPE_BY_EXTENSION[fileExtension]
		? fileExtension
		: EXTENSION_BY_MIME_TYPE[providedMimeType];
	const mimeType = TICKET_REPAIR_REPORT_PICKER_MIME_TYPES.includes(providedMimeType)
		? providedMimeType
		: MIME_TYPE_BY_EXTENSION[extension];

	if (!extension || !mimeType) {
		throw new Error('Choose a PDF, Word document or image');
	}

	if (asset.size !== null && asset.size !== undefined) {
		validateTicketRepairReportSize(asset.size);
	}

	return {
		...asset,
		extension,
		fileName: fileName || `repair-report.${extension}`,
		mimeType,
	};
};
